import React from "react";

const FilterTextarea = ({
                            label = "Description",
                            id = "formTextarea",
                            placeholder = "Enter your text here...",
                            value = "",
                            pbInput="pb-5",
                            onChange,
                            widthClass = "w-100",
                            rows = 3
                        }) => {
    return (
        <div className={`mb-3 ${widthClass}`}>
            <label htmlFor={id} className="form-label fs-6">{label}</label>
            <textarea
                className={`form-control bg-light border-light shadow-none py-2 rounded ${pbInput}`}
                id={id}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={{resize: "none"}}
                rows={rows}
            ></textarea>
        </div>
    );
};

export default FilterTextarea;
